<template>
  <div class="col-12 col-lg-10 c g">
    <div class="card card-body">
        <img :src="require('@/assets/images/banner.png')" alt="" style="width: 200px; max-width: 100%; margin: 0px auto">
        <hr>
        <h3>نظام ملف الإنجاز التفاعلي</h3>
        <h5>
            <i class="fa fa-check-square text-success"></i>
            ملف انجاز تفاعلي يتيح للموظف رفع الشواهد وفق بنود التقييم المتعمدة.
        </h5>
        <h5>
            <i class="fa fa-check-square text-success"></i>
            متاح للمعلم طوال العام.
        </h5>
        <h5>
            <i class="fa fa-check-square text-success"></i>
            إمكانية ارسال رابط الملف للمدير يتحدث بشكل تلقائي.
        </h5>
        <h5>
            <i class="fa fa-check-square text-success"></i>
            تغدية راجعة من المدير للمعلم مع إمكانية الاطلاع على الدرجة قبل رصدها في نظام فارس.
        </h5>
        <h5>
            <i class="fa fa-check-square text-success"></i>
            متوافق مع الدليل الإرشادي لإدارة الآداء الوظيفي لشاغلي الوظائف التعليمية (الإصدار الثاني).
        </h5>
        <h5>
            <i class="fa fa-check-square text-success"></i>
            متاح مجاناً للمشتركين في خدمات التحضير الذكي.
        </h5>

        <h5>
            <i class="fa fa-check-square text-success"></i>
            يمكن للمعلم الاشتراك بشكل مستقبل برسوم رمزية لمدة عام.
        </h5><br>
        <button @click="$router.push('/login')" class="btn btn-success">
        التسجيل في النظام</button>
        <br>
        <button @click="$router.push('/login')" class="btn btn-primary">
        تسجيل الدخول</button>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>